import { styled } from '@mui/material';
import Switch from '@mui/material/Switch';
import { FC } from 'react';

interface IAntSwitch {
  tab?: boolean;
  onAddTab?: (checked: boolean) => void;
  custom?: string;
}
//Переключатель - Switch
export const AntSwitch: FC<IAntSwitch> = ({ tab, onAddTab, custom }) => {
  const AntSwitchCustom = styled(Switch)(({ theme }) => ({
    width: 29,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 12,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === 'dark' ? '#FF9F2F' : '#FF9F2F',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12.5,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: custom && custom === 'catalog' ? '#C4C4C4' : '#FF9F2F',
      boxSizing: 'border-box',
    },
  }));
  return (
    <AntSwitchCustom
      checked={!tab}
      inputProps={{ 'aria-label': 'ant design' }}
      onChange={(event: any) => {
        if (onAddTab) {
          onAddTab(!event.target.checked);
        }
      }}
    />
  );
};
